import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores/authStore';
import InvitationForm from '../../components/Invitations/InvitationForm';
import InvitationsList from '../../components/Invitations/InvitationsList';
import { Users, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const InvitationsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const organizationId = user?.organization_id;

  if (!organizationId) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Users className="w-16 h-16 text-gray-400 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            {t('common.noOrganization', 'Aucune organisation')}
          </h2>
          <p className="text-gray-600 mb-4">
            {t('common.needOrganization', 'Vous devez appartenir à une organisation pour gérer les invitations.')}
          </p>
          <button
            onClick={() => navigate('/welcome')}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          >
            {t('global.backToDashboard', 'Retour au tableau de bord')}
          </button>
        </div>
      </div>
    );
  }

  const handleInvitationSuccess = () => {
    // Trigger refresh of invitations list
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-indigo-600 hover:text-indigo-700 mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('global.back', 'Retour')}
          </button>
          
          <div className="flex items-center">
            <Users className="w-8 h-8 text-indigo-600 mr-3" />
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                {t('invitations.title')}
              </h1>
              <p className="text-gray-600 mt-1">
                {t('invitations.description', 'Invitez des utilisateurs à rejoindre votre organisation')}
              </p>
            </div>
          </div>
        </div>

        {/* Invitation Form */}
        <div className="mb-8">
          <InvitationForm
            organizationId={organizationId}
            onSuccess={handleInvitationSuccess}
          />
        </div>

        {/* Invitations List */}
        <InvitationsList
          organizationId={organizationId}
          refreshTrigger={refreshTrigger}
        />
      </div>
    </div>
  );
};

export default InvitationsPage;
